import _defineProperty from "/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { resetComponent } from '../../style';
import { mergeToken } from '../../theme/internal';
function genSizeStyle(token, suffix) {
  var componentCls = token.componentCls,
    inputPaddingHorizontalBase = token.inputPaddingHorizontalBase,
    borderRadius = token.borderRadius,
    selectAffixPadding = token.selectAffixPadding;
  var selectHeightWithoutBorder = token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal();
  var suffixCls = suffix ? "".concat(componentCls, "-").concat(suffix) : '';
  return _defineProperty({}, "".concat(componentCls, "-single").concat(suffixCls), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    fontSize: token.fontSize,
    height: token.controlHeight
  }, "".concat(componentCls, "-selector"), Object.assign(Object.assign({}, resetComponent(token, true)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    borderRadius: borderRadius,
    flex: '1 1 auto'
  }, "".concat(componentCls, "-selection-wrap"), {
    display: 'flex',
    width: '100%',
    position: 'relative'
  }), "".concat(componentCls, "-selection-search"), {
    position: 'absolute',
    inset: 0,
    width: '100%',
    '&-input': {
      width: '100%',
      WebkitAppearance: 'textfield'
    }
  }), "\n          ".concat(componentCls, "-selection-item,\n          ").concat(componentCls, "-selection-placeholder,\n          ").concat(componentCls, "-prefix\n        "), {
    display: 'block',
    padding: 0,
    lineHeight: unit(selectHeightWithoutBorder),
    transition: "all ".concat(token.motionDurationSlow, ", visibility 0s"),
    alignSelf: 'center'
  }), "".concat(componentCls, "-selection-placeholder"), {
    transition: 'none',
    pointerEvents: 'none'
  }), "".concat(componentCls, "-prefix"), {
    marginInlineEnd: selectAffixPadding
  }), ['&:after', /* For '' value baseline align */"".concat(componentCls, "-selection-item:empty:after"), /* For undefined value baseline align */"".concat(componentCls, "-selection-placeholder:empty:after")].join(','), {
    display: 'inline-block',
    width: 0,
    visibility: 'hidden',
    content: '"\\a0"'
  }))), "\n        &".concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-item,\n        &").concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-search,\n        &").concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-placeholder\n      "), {
    paddingInlineEnd: token.showArrowPaddingInlineEnd
  }), "&".concat(componentCls, "-open ").concat(componentCls, "-selection-item"), {
    color: token.colorTextPlaceholder
  }), "&:not(".concat(componentCls, "-customize-input)"), _defineProperty({}, "".concat(componentCls, "-selector"), _defineProperty(_defineProperty({
    width: '100%',
    height: '100%',
    padding: "0 ".concat(unit(inputPaddingHorizontalBase))
  }, "".concat(componentCls, "-selection-search-input"), {
    height: selectHeightWithoutBorder
  }), '&:after', {
    lineHeight: unit(selectHeightWithoutBorder)
  }))), "&".concat(componentCls, "-customize-input"), _defineProperty({}, "".concat(componentCls, "-selector"), _defineProperty(_defineProperty({
    '&:after': {
      display: 'none'
    }
  }, "".concat(componentCls, "-selection-search"), {
    position: 'static',
    width: '100%'
  }), "".concat(componentCls, "-selection-placeholder"), {
    position: 'absolute',
    insetInlineStart: 0,
    insetInlineEnd: 0,
    padding: "0 ".concat(unit(inputPaddingHorizontalBase)),
    '&:after': {
      display: 'none'
    }
  }))));
}
export default function genSingleStyle(token) {
  var componentCls = token.componentCls;
  var inputPaddingHorizontalSM = token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal();
  return [genSizeStyle(token),
  // ======================== Small ========================
  // Shared
  genSizeStyle(mergeToken(token, {
    controlHeight: token.controlHeightSM,
    borderRadius: token.borderRadiusSM
  }), 'sm'), // padding
  _defineProperty({}, "".concat(componentCls, "-single").concat(componentCls, "-sm"), _defineProperty({}, "&:not(".concat(componentCls, "-customize-input)"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-selector"), {
    padding: "0 ".concat(unit(inputPaddingHorizontalSM))
  }), "&".concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-search"), {
    insetInlineEnd: token.calc(inputPaddingHorizontalSM).add(token.calc(token.fontSize).mul(1.5)).equal()
  }), "\n            &".concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-item,\n            &").concat(componentCls, "-show-arrow ").concat(componentCls, "-selection-placeholder\n          "), {
    paddingInlineEnd: token.calc(token.fontSize).mul(1.5).equal()
  }))),
  // ======================== Large ========================
  // Shared
  genSizeStyle(mergeToken(token, {
    controlHeight: token.singleItemHeightLG,
    fontSize: token.fontSizeLG,
    borderRadius: token.borderRadiusLG
  }), 'lg')];
}